// import axios from '@/api/request.js'
export default {
  /**
   * 获取url参数
   * 如不传任何参数,则返回所有key-value
   */
  getUrlParams (key) {
    try {
      var vars = []
      var hash = []
      let indx = window.location.href.indexOf('#')
      let str = window.location.href.substring(indx)
      var hashes = str.slice(str.indexOf('?') + 1).split('&')
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=')
        vars.push(hash[0])
        vars[hash[0]] = hash[1]
      }
      if (key && typeof key === 'string') {
        for (let i = 0; i < vars.length; i++) {
          if (key === vars[i]) {
            let value = vars[key]
            return value
          }
        }
        return null
      }
      return vars
    } catch (e) {
      return null
    }
  },
  saveLog (tag = '', message = '') {
    // try {
    //   message += `
    //     URL: ${window.location.href}
    //   `
    //   axios.post('cpm-digital-coupon/wc1/log/printlog', {
    //     tag,
    //     message
    //   }, undefined, false)
    // } catch (e) {
    //   // TODO...
    // }
  }
}



// WEBPACK FOOTER //
// ./src/tools/tools.js